import React, { memo, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { getCountdown } from '../helper/Countdown';

const SampleNextArrow = memo((props) => {
    const { className, onClick } = props;
    return (
        <button
            type="button" onClick={onClick}
            className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-right" />
        </button>
    );
});

const SamplePrevArrow = memo((props) => {
    const { className, onClick } = props;
    return (
        <button
            type="button"
            onClick={onClick}
            className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-left" />
        </button>
    );
});

const HotDealsOne = () => {
    const [timeLeft, setTimeLeft] = useState(getCountdown());
    const [indoorPlants, setIndoorPlants] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(getCountdown());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    // Fetch indoor plants from backend
    useEffect(() => {
        const fetchIndoorPlants = async () => {
            try {
                setLoading(true);
                const response = await fetch('http://localhost:5000/api/products/hot-deals/indoor');
                
                if (!response.ok) {
                    throw new Error('Failed to fetch indoor plants');
                }
                
                const data = await response.json();
                
                if (data.success && data.data) {
                    setIndoorPlants(data.data);
                } else {
                    setIndoorPlants([]);
                }
            } catch (err) {
                console.error('Error fetching indoor plants:', err);
                setError('Failed to load indoor plants');
            } finally {
                setLoading(false);
            }
        };

        fetchIndoorPlants();
    }, []);

    const settings = {
        dots: false,
        arrows: true,
        infinite: indoorPlants.length > 4,
        speed: 1000,
        slidesToShow: Math.min(4, indoorPlants.length),
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: Math.min(3, indoorPlants.length),
                },
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: Math.min(2, indoorPlants.length),
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    // Show loading state
    if (loading) {
        return (
            <section className="hot-deals pt-80">
                <div className="container container-lg">
                    <div className="section-heading">
                        <div className="flex-between flex-wrap gap-8">
                            <h5 className="mb-0">Hot Deals Today's</h5>
                            <div className="flex-align mr-point gap-16">
                                <Link to="/shop" className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline">
                                    View All Deals
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="text-center py-5">
                        <div className="spinner-border text-main-600" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3">Loading indoor plants...</p>
                    </div>
                </div>
            </section>
        );
    }

    // Show error state
    if (error) {
        return (
            <section className="hot-deals pt-80">
                <div className="container container-lg">
                    <div className="section-heading">
                        <div className="flex-between flex-wrap gap-8">
                            <h5 className="mb-0">Hot Deals Today's</h5>
                            <div className="flex-align mr-point gap-16">
                                <Link to="/shop" className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline">
                                    View All Deals
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="alert alert-danger text-center" role="alert">
                        {error}
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="hot-deals pt-80">
            <div className="container container-lg">
                <div className="section-heading">
                    <div className="flex-between flex-wrap gap-8">
                        <h5 className="mb-0">Hot Deals Today's</h5>
                        <div className="flex-align mr-point gap-16">
                            <Link
                                to="/shop"
                                className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
                            >
                                View All Deals
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="row g-12">
                    <div className="col-md-4">
                        <div className="hot-deals position-relative rounded-16 bg-main-600 overflow-hidden p-28 z-1 text-center">
                            <img
                                src="assets/images/shape/offer-shape.png"
                                alt=""
                                className="position-absolute inset-block-start-0 inset-inline-start-0 z-n1 w-100 h-100 opacity-6"
                            />
                            <div className="hot-deals__thumb">
                                <img 
                                    src="assets/images/thumbs/Indoor-Plant-Bundle1.png" 
                                    alt="Green Plant" 
                                />
                            </div>
                            <div className="py-xl-4">
                                <h4 className="text-white mb-8">Indoor Plant Bundle</h4>
                                <div className="countdown my-32" id="countdown4">
                                    <ul className="countdown-list flex-center flex-wrap">
                                        <li className="countdown-list__item text-heading flex-align gap-4 text-sm fw-medium colon-white">
                                            <span className="days" />
                                            {timeLeft.days} Days
                                        </li>
                                        <li className="countdown-list__item text-heading flex-align gap-4 text-sm fw-medium colon-white">
                                            <span className="hours" />
                                            {timeLeft.hours} Hours
                                        </li>
                                        <li className="countdown-list__item text-heading flex-align gap-4 text-sm fw-medium colon-white">
                                            <span className="minutes" />
                                            {timeLeft.minutes} Min
                                        </li>
                                        <li className="countdown-list__item text-heading flex-align gap-4 text-sm fw-medium colon-white">
                                            <span className="seconds" />
                                            {timeLeft.seconds} Sec
                                        </li>
                                    </ul>
                                </div>
                                <Link
                                    to="/shop"
                                    className="mt-16 btn btn-main-two fw-medium d-inline-flex align-items-center rounded-pill gap-8"
                                    tabIndex={0}
                                >
                                    Shop Now
                                    <span className="icon text-xl d-flex">
                                        <i className="ph ph-arrow-right" />
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8">
                        {indoorPlants.length > 0 ? (
                            <div className="hot-deals-slider arrow-style-two">
                                <Slider {...settings}>
                                    {indoorPlants.map((plant) => (
                                        <div key={plant._id}>
                                            <div className="product-card h-100 p-8 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                                                {plant.badge && (
                                                    <span className={`product-card__badge ${plant.badgeColor} px-8 py-4 text-sm text-white`}>
                                                        {plant.badge}
                                                    </span>
                                                )}
                                                <Link
                                                    to={`/product-details/${plant._id}`}
                                                    className="product-card__thumb flex-center"
                                                >
                                                    <img 
                                                        src={plant.image || 'https://images.unsplash.com/photo-1501004318641-b39e6451bec6?w=200&h=200&fit=crop'} 
                                                        alt={plant.name} 
                                                        onError={(e) => {
                                                            e.target.src = 'https://images.unsplash.com/photo-1501004318641-b39e6451bec6?w=200&h=200&fit=crop';
                                                        }}
                                                    />
                                                </Link>
                                                <div className="product-card__content p-sm-2">
                                                    <h6 className="title text-lg fw-semibold mt-12 mb-8">
                                                        <Link to={`/product-details/${plant._id}`} className="link text-line-2">
                                                            {plant.name}
                                                        </Link>
                                                    </h6>
                                                    <div className="flex-align gap-4">
                                                        <span className="text-main-600 text-md d-flex">
                                                            <i className="ph-fill ph-storefront" />
                                                        </span>
                                                        <span className="text-gray-500 text-xs">
                                                            By {plant.vendorName || 'GreenLeaf Nursery'}
                                                        </span>
                                                    </div>
                                                    <div className="product-card__content mt-12">
                                                        <div className="product-card__price mb-8">
                                                            <span className="text-heading text-md fw-semibold ">
                                                                ₹{plant.price.toFixed(2)}{" "}
                                                                <span className="text-gray-500 fw-normal">/Plant</span>{" "}
                                                            </span>
                                                            {plant.originalPrice && plant.originalPrice > plant.price && (
                                                                <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                                                                    ₹{plant.originalPrice.toFixed(2)}
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div className="flex-align gap-6">
                                                            <span className="text-xs fw-bold text-gray-600">{plant.rating || 0}</span>
                                                            <span className="text-15 fw-bold text-warning-600 d-flex">
                                                                <i className="ph-fill ph-star" />
                                                            </span>
                                                            <span className="text-xs fw-bold text-gray-600">
                                                                ({plant.reviewsCount ? (plant.reviewsCount > 1000 ? `${(plant.reviewsCount / 1000).toFixed(1)}k` : plant.reviewsCount) : 0})
                                                            </span>
                                                        </div>
                                                        <Link
                                                            to="/cart"
                                                            className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 mt-24 w-100 justify-content-center"
                                                        >
                                                            Add To Cart <i className="ph ph-shopping-cart" />
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        ) : (
                            <div className="text-center py-5">
                                <p>No indoor plants available at the moment.</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default HotDealsOne;